import { gql } from '@apollo/client';
const ORDEROFPLAY = gql`
  query tournamentAllMatches($viewType: String, $filter: ListGroupMatchInput, $name: String, $date: String, $hideCompleteMatches: Boolean) {
    tournamentAllMatches(viewType: $viewType, filter: $filter, name: $name, date: $date, hideCompleteMatches: $hideCompleteMatches)
  }
`;
export default ORDEROFPLAY;
